import React, { useContext } from 'react';
import styles from './Profile.module.scss';

import { SettingsContext } from '../../contexts/settings-provider';
import { auth } from '../../utils/firebase';
import { signOut, deleteUser } from 'firebase/auth';

import Main from '../../components/Main/Main';
import Button from '../../components/Button/Button';
import Heading from '../../components/Heading/Heading';
import Section from '../../components/Section/Section';

const Profile = () => {
  const [settings] = useContext(SettingsContext);

  const deleteProfile = () => {
    if (
      window.confirm(
        'Are you sure you want to delete your account? This is an ireversible act.'
      )
    ) {
      const user = auth.currentUser;
      deleteUser(user)
        .then(() => {
          signOut(auth);
        })
        .catch((error) => {
          if (
            error.toString() ===
            'FirebaseError: Firebase: Error (auth/requires-recent-login).'
          ) {
            alert(
              'Its been too long since you logged into your accout, log in and out of your account to proceed with deletion of your account'
            );
          } else {
            alert(error.toString());
          }
        });
    }
  };

  return (
    <Main>
      <Button secondary className={styles.back} link={'/'}>
        Back to frontpage
      </Button>
      <Section>
        <Heading>User profile</Heading>
        <Heading className={styles.email}> {settings.user.email}</Heading>
        <div className={styles.mainActions}>
          <Button link={'/play'}>Back to game</Button>
          <Button
            alternative
            onClick={() => {
              signOut(auth);
            }}
          >
            Sign out
          </Button>
        </div>
        <Button secondary onClick={deleteProfile}>
          Delete profile
        </Button>
      </Section>
    </Main>
  );
};

export default Profile;
